import type { ReactNode } from "react";
import { ArrowRight } from "lucide-react";

/**
 * Compact action shown inside a clickable card. It is not a link or button itself: the card is.
 * The arrow slides on hover of the parent (give the card the `group` class). Motion is off with reduced-motion.
 */
export function ActionPill({ children, tone = "primary" }: { children: ReactNode; tone?: "primary" | "ghost" }) {
  return (
    <span
      className={`inline-flex min-h-9 items-center gap-1.5 rounded-full px-3.5 text-sm font-semibold transition-colors ${
        tone === "primary" ? "bg-accent-soft text-primary group-hover:bg-primary group-hover:text-on-accent" : "text-muted-foreground group-hover:text-foreground"
      }`}
    >
      {children}
      <ArrowRight size={14} aria-hidden="true" className="transition-transform duration-200 group-hover:translate-x-1 motion-reduce:transition-none motion-reduce:group-hover:transform-none" />
    </span>
  );
}
